/**
 * 협력 제안·초대 수신자 표시용 라벨.
 * - 비회원(이메일만): 게스트 이메일
 * - 가입 후 UID 연결됨: 회원명 + 로그인 아이디(백엔드 targetUserLogin / receiverLogin), 이름만 있으면 이름만
 *   (guestTargetEmail은 UID가 있어도 남아 있을 수 있어, 연결된 회원에는 사용하지 않음)
 */
export function proposalTargetDisplayName(row) {
  const nm = row?.targetUserName ?? row?.receiverName;
  const login = row?.targetUserLogin ?? row?.receiverLogin;
  const mail = row?.guestTargetEmail;
  const linkedUid = row?.targetUserId ?? row?.receiverUid;
  const t = (v) => {
    if (v == null) return '';
    const s = String(v).trim();
    return s || '';
  };
  const namePart = t(nm);
  const loginPart = t(login);
  if (namePart && loginPart) return `${namePart} (${loginPart})`;
  if (namePart) return namePart;
  if (loginPart) return loginPart;

  const uidNum = linkedUid != null && linkedUid !== '' ? Number(linkedUid) : 0;
  if (uidNum > 0) {
    return '회원';
  }
  return t(mail) || '(이름없음)';
}
